import { Component } from 'react';
import partial from 'transmute/partial';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIButton from 'UIComponents/button/UIButton';
import UISection from 'UIComponents/section/UISection';
import UIAlert from 'UIComponents/alert/UIAlert';
import { SupportLinkKeys } from 'automation-ui-usage-tracking/SupportLinks';
import DocButton from 'automation-ui-usage-tracking/components/DocButton';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import TrackableButton from 'automation-ui-usage-tracking/components/TrackableButton';
import H2 from 'UIComponents/elements/headings/H2';
import ClassicEnrollmentFilter from 'automation-ui-management/components/goals/ClassicEnrollmentFilter';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIModal from 'UIComponents/dialog/UIModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class GoalEditModal extends Component {
  constructor(props) {
    super(props);
    this.handleOnEditingCriteria = ({
      target: {
        value
      }
    }) => {
      this.setState({
        isFooterHidden: value
      });
    };
    this.handleRedirect = () => {
      const {
        onReject,
        redirect
      } = this.props;
      onReject();
      if (redirect) {
        redirect();
      }
    };
    this.setGoal = filters => {
      this.setState({
        goalCriteria: filters
      });
    };
    const goalCriteria = props.goalCriteria;
    this.state = {
      initialGoalSize: goalCriteria.size,
      isFooterHidden: false,
      goalCriteria
    };
  }
  getPerformanceLink() {
    return /*#__PURE__*/_jsx(UIButton, {
      use: "link",
      onClick: this.handleRedirect,
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "automation-ui-management.GoalModal.performanceLink"
      })
    });
  }
  renderRemovedGoalAlert() {
    const {
      goalCriteria,
      initialGoalSize
    } = this.state;
    if (!goalCriteria.size && initialGoalSize > 0) {
      const alertTitle = /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "automation-ui-management.GoalModal.removingGoalWarningTitle"
      });
      return /*#__PURE__*/_jsx(UIAlert, {
        type: "warning",
        titleText: alertTitle,
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "automation-ui-management.GoalModal.removingGoalWarning"
        })
      });
    }
    return null;
  }
  render() {
    const {
      onReject,
      onConfirm,
      readOnly
    } = this.props;
    const {
      goalCriteria,
      isFooterHidden
    } = this.state;
    return /*#__PURE__*/_jsxs(UIModal, {
      width: 700,
      "data-test-id": "contact-goals-edit-modal",
      children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
        children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
          onClick: onReject
        }), /*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: readOnly ? 'automation-ui-management.GoalModal.headerReadOnly' : 'automation-ui-management.GoalModal.header'
          })
        })]
      }), /*#__PURE__*/_jsxs(UIDialogBody, {
        children: [/*#__PURE__*/_jsxs(UISection, {
          children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "automation-ui-management.GoalModal.info",
            options: {
              performanceLink: this.getPerformanceLink()
            }
          }), /*#__PURE__*/_jsx(DocButton, {
            supportKey: SupportLinkKeys.LEARN_MORE_ABOUT_GOALS,
            children: /*#__PURE__*/_jsx(FormattedReactMessage, {
              message: "automation-ui-management.GoalModal.learnGoals"
            })
          })]
        }), readOnly && !goalCriteria.size ? /*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "automation-ui-management.GoalModal.zeroState"
          })
        }) : /*#__PURE__*/_jsx(ClassicEnrollmentFilter, {
          value: goalCriteria,
          onChange: this.setGoal,
          onEditingCriteria: this.handleOnEditingCriteria,
          "data-test-id": "enrollment-filter",
          readOnly: readOnly
        }), this.renderRemovedGoalAlert()]
      }), !isFooterHidden && /*#__PURE__*/_jsxs(UIDialogFooter, {
        children: [/*#__PURE__*/_jsx(TrackableButton, {
          "data-test-id": "contact-goals-edit-modal-save-button",
          onClick: partial(onConfirm, {
            goalCriteria
          }),
          use: "primary",
          type: "submit",
          trackableKey: Trackables.SAVED_GOALS,
          disabled: readOnly,
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "automation-ui-management.GoalModal.save"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          use: "secondary",
          type: "submit",
          onClick: onReject,
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "automation-ui-management.GoalModal.cancel"
          })
        })]
      })]
    });
  }
}